export default function DangerNotifyMedium() {
  return (
    <>
      <svg width="18" height="18" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.25 0.623535C2.7675 0.623535 0.75 2.64104 0.75 5.12354C0.75 7.60604 2.7675 9.62354 5.25 9.62354C7.7325 9.62354 9.75 7.60604 9.75 5.12354C9.75 2.64104 7.7325 0.623535 5.25 0.623535ZM5.25 8.49854C3.39 8.49854 1.875 6.98354 1.875 5.12354C1.875 3.26354 3.39 1.74854 5.25 1.74854C7.11 1.74854 8.625 3.26354 8.625 5.12354C8.625 6.98354 7.11 8.49854 5.25 8.49854Z"
          fill="#FF3D3D"
          style={{
            fill: "#FF3D3D",
            fillOpacity: 1,
          }}
        />
        <path
          d="M5.8125 2.62598H4.6875V5.87348H5.8125V2.62598Z"
          fill="#FF3D3D"
          style={{
            fill: "#FF3D3D",
            fillOpacity: 1,
          }}
        />
        <path
          d="M5.8125 6.62354H4.6875V7.74854H5.8125V6.62354Z"
          fill="#FF3D3D"
          style={{
            fill: "#FF3D3D",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
}
